/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiNoteInfo
 */
export interface ApiNoteInfo {
    /**
     * 
     * @type {number}
     * @memberof ApiNoteInfo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiNoteInfo
     */
    content: string;
}

/**
 * Check if a given object implements the ApiNoteInfo interface.
 */
export function instanceOfApiNoteInfo(value: object): value is ApiNoteInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ApiNoteInfoFromJSON(json: any): ApiNoteInfo {
    return ApiNoteInfoFromJSONTyped(json, false);
}

export function ApiNoteInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNoteInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
    };
}

export function ApiNoteInfoToJSON(json: any): ApiNoteInfo {
    return ApiNoteInfoToJSONTyped(json, false);
}

export function ApiNoteInfoToJSONTyped(value?: ApiNoteInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
    };
}

